// 会场管理 mutations - 处理登录相关状态变更，并持久化到本地缓存
const CACHE_KEY = 'venueManage'

/** 保存状态到本地缓存 */
function saveToCache(state) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(state))
  } catch (e) {
    console.warn('venueManage cache save failed', e)
  }
}

/** 清除本地缓存 */
function clearCache() {
  localStorage.removeItem(CACHE_KEY)
}

export default {
  /** 设置登录状态 */
  setLogin(state, isLogin) {
    state.isLogin = isLogin
    saveToCache(state)
  },

  /** 设置登录数据（登录成功后调用，保存到缓存） */
  setLoginData(state, loginData) {
    state.loginInfo = loginData || {}
    state.token = loginData?.staff_token || ''
    state.isLogin = true
    saveToCache(state)
  },

  /** 清除登录数据（登出时调用，同时清除缓存） */
  clearLoginData(state) {
    state.loginInfo = {}
    state.token = ''
    state.isLogin = false
    clearCache()
  }
}
